import { useMount } from 'ahooks';
import React from 'react';
import { makeApiaUrl } from '../../../api/apiaApi/apiaApi';
import EventEmitter from '../../../utils/util/eventEmitter';
import IFrameOverlay from '../../common/dialogs/layout/IFrameOverlay';

export interface IEntityData {
  entName: string;
  entNum?: number;
  height?: number;
  parameters?: string;
  viewMode?: boolean;
  width?: number;
}

export const AdminEntityController = new (class extends EventEmitter<{
  adminEntity: IEntityData;
}> {})();

const AdminEntity = () => {
  const [data, setData] = React.useState<IEntityData | undefined>(undefined);

  useMount(() => {
    function processData(newData: IEntityData) {
      setData({ ...newData });
    }

    AdminEntityController.on('adminEntity', processData);

    return () => {
      AdminEntityController.off('adminEntity', processData);
    };
  });

  const listenForClose = React.useCallback(() => {
    setData(undefined);
  }, []);

  return data ? (
    <IFrameOverlay
      src={makeApiaUrl({
        ajaxUrl: '/apia.execution.EntInstanceListAction.run',
        action: 'admEntity',
        ...(data.viewMode ? { viewMode: true } : undefined),
        busEntName: data.entName,
        busEntNum: data.entNum,
        tabId: new Date().getTime(),
      })}
      onClose={listenForClose}
    />
  ) : null;
};

export default AdminEntity;
